import { Box, Typography, useTheme } from "@mui/material";
import React, { ForwardedRef, forwardRef, useState } from "react";
import BarDetailsBottomSheet from "./BarDetailsBottomSheet";
import Boxoutline from "../../../../../media/images/icons/outline-box";
import CustomButton from "../../../../components/CustomButton";
import { splitPelak } from "../../../../../utils/functions";
import CarTagView from "../../../../components/CarTag";
import ArrowTickLeft from "../../../../../media/images/icons/arrow-tick-left";
import useSWRMutation from "swr/mutation";
import { fetcherPost } from "../../../../../services/fetcher";
import { useAppDispatch } from "../../../../../hooks/useRedux";
import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../../../redux/features/snackbarSlice";
import { ITrackingDto } from "../../../../../types/trackingPage";

interface Props {
  billsItem: ITrackingDto;
  setBillsItems: React.Dispatch<React.SetStateAction<ITrackingDto[]>>;
}

const CompleteCargoCard = forwardRef(
  (props: Props, ref: ForwardedRef<HTMLDivElement>) => {
    const { setBillsItems } = props;
    const { orderInfo, bol, driverInfo, vehicleInfo, id, shipStatusDt5 } =
      props.billsItem;
    const theme = useTheme();

    const [barDetailsBottomSheet, setBarDetailsBottomSheet] = useState(false);

    const { alpha, firstTowDigits, lastThiredDigits } = splitPelak(
      vehicleInfo.licensePlateNr
    );

    const dispatch = useAppDispatch();

    const {
      trigger: setShipStatusTrigger,
      isMutating: setShipStatusTriggerMutating,
    } = useSWRMutation(
      [`/Nobat/SetShipStatus`, localStorage.getItem("access_token")],
      fetcherPost,
      {
        onSuccess: async () => {},
      }
    );
    return (
      <>
        <BarDetailsBottomSheet
          onDismiss={() => setBarDetailsBottomSheet(false)}
          open={barDetailsBottomSheet}
          trackingData={props.billsItem}
        />
        <Box
          ref={ref}
          sx={{
            padding: "8px",
            borderColor: "bgColor.blueGrey100",
            borderWidth: "1px",
            borderStyle: "solid",
            borderRadius: "16px",
            backgroundColor: "bgColor.white",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                gap: "8px",
                width: "100%",
              }}
            >
              <Box
                sx={{
                  backgroundColor: theme.palette.bgColor.blueGrey100,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "6px",
                  borderRadius: "8px",
                }}
              >
                <Boxoutline color={theme.palette.textColor.main} />
              </Box>
              <Box
                sx={{
                  flex: 1,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "700",
                      fontSize: "14px",
                    }}
                  >
                    شماره بارنامه:
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "14px",
                    }}
                  >
                    {bol?.bolNr}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "700",
                      fontSize: "14px",
                    }}
                  >
                    سری بارنامه:
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "14px",
                    }}
                  >
                    {bol?.bolSerialNr}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "700",
                      fontSize: "14px",
                    }}
                  >
                    نام راننده:
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "14px",
                    }}
                  >
                    {driverInfo.fullName}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: "700",
                    }}
                  >
                    نام محموله:
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: "600",
                    }}
                  >
                    {orderInfo?.goodsInfo?.name}
                  </Typography>
                </Box>
                {/* <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "700",
                  }}
                >
                  کرایه:
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                  }}
                  noWrap
                >
                  {addCommas(orderInfo?.bolFare!)}
                  ریال
                </Typography>
              </Box> */}
                {/* <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "700",
                  }}
                >
                  تناژ / بسته‌بندی:
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                  }}
                >
                  <Typography noWrap variant="body2">
                    {orderInfo?} تن
                  </Typography>
                  /
                  <Typography noWrap variant="body2">
                    {orderInfo?.packageTypeInfo?.name!}
                  </Typography>
                </Box>
              </Box> */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: "700",
                    }}
                  >
                    پلاک:
                  </Typography>
                  <CarTagView
                    alpha={alpha}
                    firstTowDigits={firstTowDigits}
                    lastThiredDigits={lastThiredDigits}
                    licensePlateSerial={vehicleInfo.licensePlateSerial}
                  />
                </Box>
                {/* <Box
                sx={{
                  display: "flex",
                }}
              >
                <Box
                  sx={{
                    width: "fit-content",
                    borderColor: "info.main",
                    borderWidth: "1px",
                    borderStyle: "solid",
                    backgroundColor: "background.default",
                    padding: "2px",
                    borderRadius: "6px",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "14px",
                    }}
                    noWrap
                  >
                    {addCommas(orderInfo?.goodsCost!)}
                    ریال
                  </Typography>
                </Box>
                <Box
                  sx={{
                    borderColor: "info.main",
                    borderWidth: "1px",
                    borderStyle: "solid",
                    width: "fit-content",
                    backgroundColor: "background.default",
                    padding: "2px",
                    borderRadius: "6px",
                  }}
                >
                  <Typography noWrap variant="body2">
                    {orderInfo?.truckWeightTo} تن
                  </Typography>
                </Box>
              </Box> */}
              </Box>
              {/* <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "column",
              }}
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: "700",
                }}
              >
                {goodsName}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography variant="body2" sx={{}}>
                  وضعیت:
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "success.main",
                  }}
                >
                  بارنامه صادرشده
                </Typography>
              </Box>
            </Box> */}
            </Box>
            {/* <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              flexWrap: "wrap",
              gap: "4px",
              justifyContent: "end",
            }}
          >
            <Box
              sx={{
                borderColor: "info.main",
                borderWidth: "1px",
                borderStyle: "solid",
                backgroundColor: "background.default",
                padding: "2px",
                borderRadius: "6px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "14px",
                }}
                noWrap
              >
                {addCommas(orderInfo?.goodsCost!)}
                ریال
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                gap: "4px",
                justifyContent: "end",
              }}
            >
              <Box
                sx={{
                  borderColor: "info.main",
                  borderWidth: "1px",
                  borderStyle: "solid",
                  backgroundColor: "background.default",
                  padding: "2px",
                  borderRadius: "6px",
                }}
              >
                <Typography noWrap variant="body2">
                  {orderInfo?.truckWeightTo} تن
                </Typography>
              </Box>
              <Box
                sx={{
                  borderColor: "info.main",
                  borderWidth: "1px",
                  borderStyle: "solid",
                  backgroundColor: "background.default",
                  padding: "2px",
                  borderRadius: "6px",
                }}
              >
                <Typography noWrap variant="body2">
                  {orderInfo?.packageTypeInfo.name!}
                </Typography>
              </Box>
            </Box>
          </Box> */}
          </Box>

          <Box
            sx={{
              display: "flex",
              mt: 1,
              gap: "8px",
            }}
          >
            <CustomButton
              onClick={() => setBarDetailsBottomSheet(true)}
              flex={1}
              justifyContent="center"
              title=" جزئیات بار"
              bgColor="primary.main"
              fSize="14px"
              px="6px"
              py="8px"
              borderRadius="6px"
              icon2={<ArrowTickLeft size={18} color={"#fff"} />}
            />
            {!shipStatusDt5 ? (
              <CustomButton
                loading={setShipStatusTriggerMutating}
                onClick={() =>
                  setShipStatusTrigger({
                    id,
                    input: 5,
                  })
                    .then(() => {
                      setBillsItems((prev) =>
                        prev.map((item) => {
                          if (item.id === id) {
                            return {
                              ...item,
                              shipStatus: 5,
                              shipStatusDt5: new Date().toISOString(),
                            };
                          } else {
                            return item;
                          }
                        })
                      );
                    })
                    .catch((e) => {
                      console.error(e);
                    })
                }
                flex={1}
                justifyContent="center"
                title="رسید کالا"
                bgColor="secondary.main"
                fSize="14px"
                px="6px"
                py="8px"
                borderRadius="6px"
                // icon1={<StarFillSVG size={22} color={"#fff"} />}
              />
            ) : (
              <Box
                sx={{
                  flex: "1",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "success.light",
                  borderRadius: "4px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: "success.main",
                  }}
                >
                  رسید شده
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      </>
    );
  }
);

export default CompleteCargoCard;
